import React from 'react'
import Paper from '../Paper'
import { makeStyles } from '@material-ui/core'
import Typography from '../Typography'
import type { PipelineProgressBarProps } from '../PipelineProgressBar'
import PipelineProgressBar from '../PipelineProgressBar'

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    padding: theme.spacing(2)
  },
  selectContainer: {
    marginTop: theme.spacing(4)
  }
}))

interface PipelineSelectContainerProps extends PipelineProgressBarProps {}

export default function PipelineSelectContainer(props: PipelineSelectContainerProps) {
  const classes = useStyles(props)
  return (
    <Paper className={classes.root}>
      <Typography variant={'h3'}>Pipeline & Stage</Typography>
      <div className={classes.selectContainer}>
        <PipelineProgressBar {...props} showSelectOnMobile />
      </div>
    </Paper>
  )
}
